module.exports = __webpack_public_path__ + "static/media/Pariksha Manthan Computer Ek Parichay Book.f4841cf4.pdf";